// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as MoreVerticalComponent} from './MoreVertical.svg';

import Icon, { TIconProps } from '../Icon';

export const IconMoreVertical = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <MoreVerticalComponent/>
  </Icon>
));
